var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTellAFriendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 5.8335H14.375V7.0835H15.625C16.4292 7.0835 17.0833 7.73766 17.0833 8.54183V17.3147L13.4925 14.7031C13.3858 14.6256 13.2571 14.5835 13.125 14.5835H7.70833C6.90417 14.5835 6.25 13.9293 6.25 13.1252V11.9131L5 12.8222V13.1252C5 14.6185 6.215 15.8335 7.70833 15.8335H12.9217L16.6504 18.5452C16.8358 18.6797 17.0533 18.7485 17.2729 18.7485C17.4371 18.7485 17.6021 18.7102 17.7546 18.6322C18.1117 18.4506 18.3333 18.0885 18.3333 17.6881V8.54183C18.3333 7.0485 17.1183 5.8335 15.625 5.8335Z",
    fill: "#131313"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2917 2.7085H4.37499C3.22457 2.7085 2.29166 3.64141 2.29166 4.79183V11.4585V13.9381C2.29166 14.2935 2.69457 14.4985 2.98207 14.2897L6.87499 11.4585H12.2917C13.4421 11.4585 14.375 10.5256 14.375 9.37516V4.79183C14.375 3.64141 13.4421 2.7085 12.2917 2.7085Z",
    stroke: "#131313",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 5.625H11.0417",
    stroke: "#131313",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 8.5415H9.79167",
    stroke: "#131313",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTellAFriendIcon);
export default __webpack_public_path__ + "static/media/tell-a-friend-icon.2543340bc577b64d1a79dd8dce429048.svg";
export { ForwardRef as ReactComponent };